import { OutdatedData } from '#/components/OutdatedData'
import { minutesToHours } from '#/utils'

export interface TypeOutdatedValueProps {
  /** Texto e asterisco brancos, para fundos escuros. */
  invertColors?: boolean
  /** Data da leitura que gerou o valor; define asterisco ou ocultação por dado desatualizado. */
  timestamp?: string
  /** Valor exibido; em minutos quando `withMinutesToHours` está ativo. */
  value?: number | null
  /** Exibe as horas ao lado do valor em minutos. */
  withMinutesToHours?: boolean
}

const TypeOutdatedValue = ({
  invertColors,
  timestamp,
  value,
  withMinutesToHours = true,
}: TypeOutdatedValueProps) => {
  if (!value) {
    return <span>-</span>
  }

  return (
    <OutdatedData timestamp={timestamp} style={invertColors ? { color: '#fff' } : undefined}>
      {withMinutesToHours ? (
        <span>
          {value} ({minutesToHours(value)})
        </span>
      ) : (
        value
      )}
    </OutdatedData>
  )
}

export default TypeOutdatedValue
